import { freeSamplesSortingTypes } from '@elab/core/utils/constants';

import { storeName } from './types';

const getState = state => state[storeName] || {};
const getSamples = (state, sortingType) => {
    const { stockLevel, recentlyAdded, alphabetical } = freeSamplesSortingTypes;
    const products = getState(state).products || [];

    if (sortingType && sortingType === stockLevel) {
        return products.sort(
            ({ stock: { stockLevel: stockLevelA } }, { stock: { stockLevel: stockLevelB } }) =>
                stockLevelB - stockLevelA,
        );
    }
    if (sortingType && sortingType === recentlyAdded) {
        return products.sort(
            ({ modifiedTime: modifiedTimeA }, { modifiedTime: modifiedTimeB }) =>
                new Date(modifiedTimeB) - new Date(modifiedTimeA),
        );
    }
    if (sortingType && sortingType === alphabetical) {
        return products.sort((productA, productB) =>
            productA.name > productB.name ? 1 : productB.name > productA.name ? -1 : 0,
        );
    }
    return products;
};
const isCheckedRemoveSamples = state => getState(state).checkedRemoveSamples;
const getCategoryCode = state => getState(state).categoryCode;
const isLoading = state => getState(state).loading;
const isSamplesHidden = state => getState(state).hideFreeSamples;
const getClickedSample = state => getState(state).clickedSample || null;

export default {
    getSamples,
    isCheckedRemoveSamples,
    getCategoryCode,
    isLoading,
    isSamplesHidden,
    getClickedSample,
};
